"use client";
import type { ReactElement } from "react";
import { createMarkdownHeadingAccentBarStyle } from "./markdown-heading-styles";
import type { MarkdownHeadingAccentBarConfig } from "./markdown-heading-types";
interface CmarkdownheadingAccentBarProps {
    accentBar: MarkdownHeadingAccentBarConfig;
    size: number;
}
export function CmarkdownheadingAccentBar({ accentBar, size, }: CmarkdownheadingAccentBarProps): ReactElement {
    return (
      <span aria-hidden="true" style={createMarkdownHeadingAccentBarStyle({ accentBar, size })}/>
    );
}
